module.exports = __webpack_public_path__ + "static/media/bulk_upload_template.07ff65c6.xlsx";